/**
 * DevExtreme (esm/__internal/scheduler/view_model/filtering/utils/get_raw_appointments.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const getRawAppointments = items => items.map(_ref => {
  let {
    rawAppointment: rawAppointment
  } = _ref;
  return rawAppointment;
});